import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Instagram = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...rest}
    >
      <g id="instagram" clipPath="url(#clip0_3001_4883)">
        <path
          id="Vector (Stroke)"
          d="M4.49609 1.50012C3.70044 1.50012 2.93738 1.81619 2.37477 2.3788C1.81216 2.94141 1.49609 3.70447 1.49609 4.50012V11.5001C1.49609 12.2958 1.81216 13.0588 2.37477 13.6214C2.93738 14.1841 3.70044 14.5001 4.49609 14.5001H11.4961C12.2917 14.5001 13.0548 14.1841 13.6174 13.6214C14.18 13.0588 14.4961 12.2958 14.4961 11.5001V4.50012C14.4961 3.70447 14.18 2.94141 13.6174 2.3788C13.0548 1.81619 12.2917 1.50012 11.4961 1.50012H4.49609ZM1.66767 1.67169C2.41781 0.921549 3.43523 0.500122 4.49609 0.500122H11.4961C12.557 0.500122 13.5744 0.921549 14.3245 1.67169C15.0747 2.42184 15.4961 3.43926 15.4961 4.50012V11.5001C15.4961 12.561 15.0747 13.5784 14.3245 14.3285C13.5744 15.0787 12.557 15.5001 11.4961 15.5001H4.49609C3.43523 15.5001 2.41781 15.0787 1.66767 14.3285C0.917521 13.5784 0.496094 12.561 0.496094 11.5001V4.50012C0.496094 3.43926 0.917521 2.42184 1.66767 1.67169ZM11.9336 3.56262C12.2097 3.56262 12.4336 3.78648 12.4336 4.06262V4.07137C12.4336 4.34751 12.2097 4.57137 11.9336 4.57137C11.6575 4.57137 11.4336 4.34751 11.4336 4.07137V4.06262C11.4336 3.78648 11.6575 3.56262 11.9336 3.56262ZM5.78638 5.79041C6.37244 5.20436 7.16729 4.87512 7.99609 4.87512C8.82489 4.87512 9.61975 5.20436 10.2058 5.79041C10.7919 6.37646 11.1211 7.17132 11.1211 8.00012C11.1211 8.82892 10.7919 9.62378 10.2058 10.2098C9.61975 10.7959 8.82489 11.1251 7.99609 11.1251C7.16729 11.1251 6.37244 10.7959 5.78638 10.2098C5.20033 9.62378 4.87109 8.82892 4.87109 8.00012C4.87109 7.17132 5.20033 6.37646 5.78638 5.79041ZM7.99609 5.87512C7.43251 5.87512 6.89201 6.09901 6.49349 6.49752C6.09498 6.89603 5.87109 7.43654 5.87109 8.00012C5.87109 8.56371 6.09498 9.10421 6.49349 9.50272C6.89201 9.90124 7.43251 10.1251 7.99609 10.1251C8.55968 10.1251 9.10018 9.90124 9.4987 9.50272C9.89721 9.10421 10.1211 8.56371 10.1211 8.00012C10.1211 7.43654 9.89721 6.89603 9.4987 6.49752C9.10018 6.09901 8.55968 5.87512 7.99609 5.87512Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_3001_4883">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  );
};

Instagram.displayName = 'Instagram';
